import { auth } from "../../lib/firebase";

const getSignupEndpoint = () => {
  if (process.env.REACT_APP_SHOW_SIGNUP_URL) return process.env.REACT_APP_SHOW_SIGNUP_URL;

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
  return projectId
    ? `https://us-central1-${projectId}.cloudfunctions.net/signUpForShow`
    : "";
};

export const signUpForPilotShow = async (showId) => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Please verify your mobile number before signing up.");

  const endpoint = getSignupEndpoint();
  if (!endpoint) {
    throw new Error("Show signup is not configured yet.");
  }

  const idToken = await currentUser.getIdToken();
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ showId }),
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(body?.error || "We could not sign you up for this show right now.");
  }

  return body;
};
